import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isClientAdmin } from 'shared/domain/role/isClientAdmin';
import React from 'react';
import { useCurrentUserRole } from 'store/user';
import { MemoEditOrganizationWizardContainer } from 'views/organization/wizard/edit/container';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';
import { isSuperAdmin } from 'shared/domain/role/isSuperAdmin';

export const AuthorizableEditOrganizationWizard = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();
    const isCurrentUserClientAdmin = isClientAdmin(role) || isSuperAdmin(role);
    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserClientAdmin}
        unauthorized={!isCurrentUserClientAdmin}
        authorizedComponent={MemoEditOrganizationWizardContainer}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);
